import React, { useMemo } from 'react'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { BNGM_SCOPE, BuyNGetMRuleState } from './types'
import {
	RuleSummaryArrow,
	RuleSummaryEligibleProducts,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'
import { resolveEligibleNames } from './ConfirmationSummary.helpers'
import { pluralize } from 'src/utils/stringUtils'

export function BuyNGetMConfirmationSummary({
	rule,
	sections,
	allMenus,
	selectedShopIds,
}: ConfirmationSummaryProps<BuyNGetMRuleState>) {
	const totalProductsRequired = rule.numProductsPaid + rule.numProductsDiscounted

	const names = useMemo(
		() => resolveEligibleNames(rule, sections, allMenus, selectedShopIds),
		[rule, sections, allMenus, selectedShopIds],
	)

	const eligibleTitle =
		rule.scopeType === BNGM_SCOPE.PRODUCTS ? 'Produits éligibles' : "Liste d'options éligible"

	return (
		<>
			<RuleSummaryMechanicsRow>
				<RuleSummaryStatBadge
					value={totalProductsRequired}
					caption={`acheté${pluralize(totalProductsRequired)}`}
				/>
				<RuleSummaryArrow />
				<RuleSummaryStatBadge
					value={`−${rule.discountPercent}%`}
					caption={`sur ${rule.numProductsDiscounted} moins cher${pluralize(rule.numProductsDiscounted)}`}
					tone="accent"
				/>
			</RuleSummaryMechanicsRow>
			<RuleSummaryEligibleProducts
				title={eligibleTitle}
				names={names}
				variant="review"
			/>
		</>
	)
}
